import React from 'react';
import { convertZonesToTableData } from '../../utils';
import { EnhancedTable } from '../../components';
import { useAppDispatch, useAppSelector } from '../../store/store.hook';
import { selectCurrentUserInfo, updateLayout } from '../../store/slices';
import { useQueryValues } from '../../hooks/url.hook';
import { useZonesTableRows } from './zones.hook';
import { ZonesLayout } from '../../layouts';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { useAddItemsToCartMutation } from '../../store/apis/decal-order.api';
import { toast } from 'react-toastify';

export const OrderDecalsPage = () => {
  const dispatch = useAppDispatch();
  const { isAdmin } = useAppSelector(selectCurrentUserInfo);
  const [selected, setSelected] = React.useState<any[]>([]);
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);

  const { building: buildingIdStr } = useQueryValues(['building']);
  const buildingId = buildingIdStr ? Number(buildingIdStr) : null;

  const [loading, columnKeys, columns, rows] = useZonesTableRows({ buildingId });

  const [mutate, { isLoading, isSuccess, isError, ...rest }] = useAddItemsToCartMutation();

  React.useEffect(() => {
    dispatch(updateLayout({ headerTitle: 'Order Decals' }));
  }, []);

  React.useEffect(() => {
    if (isSuccess) {
      toast.success(<Msg msg={`Successfully added ${selected.length} zones to cart`} />, {
        autoClose: 5000,
      });
    }
  }, [isSuccess]);

  React.useEffect(() => {
    if (isError && rest.error) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      toast.error(<Msg msg={rest.error.data.payload.message} />, {
        autoClose: 5000,
      });
    }
  }, [isError]);

  const Msg = ({ msg }: { msg: string }) => {
    return (
      <Box>
        <Typography variant="body2">{msg}</Typography>
      </Box>
    );
  };

  const handleAddZonesToCart = () => {
    console.log('addZonesToCart');
    const zones = selected.map((zoneId: number) => ({
      zone_id: zoneId,
      quantity: 1,
    }));

    console.log({ zones });

    mutate({ orgSlug, body: { zones } });
  };

  return (
    <ZonesLayout hideCreateButton>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Button
          variant="contained"
          size="small"
          sx={{ mr: 1 }}
          onClick={handleAddZonesToCart}
          disabled={selected.length === 0 || isLoading}
          endIcon={
            isLoading && (
              <Box
                sx={{
                  width: '32px',
                  marginLeft: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <CircularProgress color="inherit" size={14} />
              </Box>
            )
          }
        >
          Add To Cart
        </Button>
        <Typography>{selected.length} zones selected</Typography>
      </Box>
      <EnhancedTable
        config={{ toolbar: false, rowCheckable: true }}
        loading={loading}
        loadingLabel={'Loading zones'}
        noDataLabel={'No zones'}
        data={rows}
        convertFunctionForDataToTableData={convertZonesToTableData(isAdmin)}
        headColumns={columns}
        columnKeys={columnKeys}
        defaultSortColumnName="floorInfo"
        defaultSortDirection="asc"
        styles={{ tableStyle: { minWidth: 0 } }}
        initialRowsPerPage={10}
        visiblePagination
        rowActions={{}}
        selected={selected}
        setSelected={(selected: any[]) => setSelected(selected)}
      />
    </ZonesLayout>
  );
};
